module.exports = __webpack_public_path__ + "img/plant.d6901790.png";